import React from "react";
import "./AboutGallery.css";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

function AboutGallery(props) {
  const [count, setCount] = React.useState(0);
  const slides = [
    "./img/img-1.jpeg",
    "./img/img-2.jpeg",
    "./img/img-3.jpeg",
    "./img/img-4.jpg",
    "./img/img-5.jpg",
    "./img/img-7.jpg",
  ];

  let countVal = count;
  const handleSlide = (e) => {
    const targetEl = e.target.id;
    // console.log(targetEl);
    if (targetEl === "prev") {
      countVal--;
      console.log(countVal < 1);
      if (countVal < 1) {
        countVal = 0;
        setCount(countVal);
      }
      setCount(countVal);
    }
    if (targetEl === "next") {
      countVal++;
      // console.log(countVal);
      console.log(countVal > slides.length - 1);
      if (countVal > slides.length - 1) {
        countVal = 0;
        setCount(countVal);
      }
      setCount(countVal);
    }
  };

  const gallerySlides = () => {
    return slides.map((slide, i) => {
      return (
        <div
          key={i}
          className="aboutgallery___imgcontainer"
          style={{ transform: `translateX(${(i - count) * 100}%)` }}
        >
          <img className="gallery__imgs" src={slide} />
        </div>
      );
    });
  };

  return (
    <>
      <h2 className="gallery__Title">Our Moments</h2>
      <div className="AboutGallery">
        <div className="aboutgallery___container">{gallerySlides()}</div>
        <div className="gallary__slide-controller">
          <IoChevronBack size={30} id="prev" onClick={handleSlide} />
          <IoChevronForward size={30} id="next" onClick={handleSlide} />
        </div>
      </div>
    </>
  );
}

export default AboutGallery;
